import script from "./DynamicContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./DynamicContent.vue?vue&type=script&setup=true&lang=ts"

import "./DynamicContent.vue?vue&type=style&index=0&id=5d151044&lang=scss"
import "./DynamicContent.vue?vue&type=style&index=1&id=5d151044&scoped=true&lang=scss"
import "./DynamicContent.vue?vue&type=style&index=2&id=5d151044&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/deployJob/project/music-teach/h5-internal-examination/code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d151044"]])

export default __exports__